import React, { useState } from "react";
import { useStripe, useElements, CardNumberElement } from "@stripe/react-stripe-js";

import { Container } from "./index.style";
import PaymentForm from "./PaymentForm";
import Utils from "../../../lib/utils";

const createPaymentMethod = (
  stripe,
  props,
  cardElement,
  cardDetails,
  setPending,
  history,
) => {
  const { address1, address2, cardOwner } = cardDetails;
  setPending(true);
  stripe
    .createPaymentMethod({
      type: "card",
      card: cardElement,
    })
    .then(({ error, paymentMethod }) => {
      if (error) {
        props.notify("error", error.message);
      } else {
        props.notify("success", "Your payment details have been confirmed");
        const cart = Utils.getCart();
        const newCart = {
          ...cart,
          paymentMethod,
          company: {
            address1,
            address2,
            cardOwner,
          },
        };
        Utils.setCart(newCart);
        setTimeout(() => {
          history.push("/checkout");
        }, 1000);
      }
      setPending(false);
    });
};

const Payment = (props) => {
  // check if the user is signed up, else go to signed page
  if (!Utils.getCart().plan) props.history.push("/subscriptions");
  if (!Utils.isSignedIn()) props.history.push("/employer-signup");

  const stripe = useStripe();
  const elements = useElements();
  const company = Utils.getCart() && Utils.getCart().company;
  const [address1, setAdress1] = useState(company && company.address1);
  const [address2, setAdress2] = useState(company && company.address2);
  const [cardOwner, setCardOwner] = useState(company && company.cardOwner);
  const [pending, setPending] = useState(false);

  const handleSubmit = (event) => {
    const cardElement = elements.getElement(CardNumberElement);
    event.preventDefault();
    const cardDetails = { address1, address2, cardOwner };
    createPaymentMethod(
      stripe,
      props,
      cardElement,
      cardDetails,
      setPending,
      props.history
    );
  };

  const handleAdress1 = (event) => setAdress1(event.target.value);
  const handleAdress2 = (event) => setAdress2(event.target.value);
  const handleCardOwner = (event) => setCardOwner(event.target.value);

  return (
    <Container>
      <PaymentForm
        handleAdress1={handleAdress1}
        handleAdress2={handleAdress2}
        handleCardOwner={handleCardOwner}
        handleSubmit={handleSubmit}
        address1={address1}
        address2={address2}
        cardOwner={cardOwner}
        loading={pending}
      />
    </Container>
  );
};

export default Payment;
